@if (clientRequest) {
<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
    />
  </div>
  <div class="dialogContent">
    <app-dialog-input-title
      title="Navn"
      [required]="true"
    ></app-dialog-input-title>
    <input type="text" [(ngModel)]="clientRequest.name" />
  </div>
  <div class="dialogFooter">
    <app-save-button
      [disabled]="clientRequest.name == ''"
      [clickEvent]="saveChanges.bind(this)"
    >
    </app-save-button>
    @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin) {
    <app-delete-button [clickEvent]="deleteEntry.bind(this)">
    </app-delete-button>
    }
  </div>
</div>
}
